// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconAlphaS = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M12.118 17.224c-2.072 0-3.542-.966-3.864-2.926l1.708-.154c.196.994.994 1.61 2.212 1.61 1.204 0 1.904-.616 1.904-1.526s-.714-1.148-1.876-1.47l-.756-.21c-1.792-.504-2.884-1.316-2.884-2.912 0-1.68 1.372-2.884 3.57-2.884 2.058 0 3.318 1.064 3.528 2.702l-1.68.14c-.21-.84-.812-1.33-1.904-1.33-1.022 0-1.638.532-1.638 1.274 0 .84.7 1.106 1.848 1.47l.714.224c1.806.56 2.912 1.12 2.912 2.87 0 1.876-1.568 3.122-3.794 3.122" />,
    <path
      fillRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1116 0 8 8 0 01-16 0"
    />
  );
export default SvgIconAlphaS;
